module.exports = __webpack_public_path__ + "img/live.ae3650c9.png";